import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BusyService } from '@shared/services/busy.service';
import { StringsService } from '@shared/services/strings.service';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss'],
})
export class ModalContentComponent implements OnInit, OnChanges {
  @Input() width: string;
  @Input() modalTitle: string;
  @Input() successBtnContent = this.stringsService.strings.accept;
  @Input() hiddenButtons: ('success' | 'close')[] = [];

  @Output() closeModal = new EventEmitter();
  @Output() successModal = new EventEmitter();

  modalTitleChartsLimit = 45;

  constructor(
    public busyService: BusyService,
    public stringsService: StringsService,
  ) {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hiddenButtons) {
      if (!Array.isArray(this.hiddenButtons)) {
        this.hiddenButtons = [];
      }
    }
  }
}
